import { Suspense, lazy } from 'react';
import { ThemeProvider } from '@mui/material';
import { Navigate, Route, Routes } from 'react-router-dom';
import { theme } from '../theme';
import { HomePage } from './home/HomePage';
import AppErrorBoundary from './AppErrorBoundary';
import { Layout } from './Layout/Layout';
import { PrivacyPolicyPage } from './privacy-policy/PrivacyPolicyPage';
import RouteChangeTracker from './RouteChangeTracker';

const ChecklistPage = lazy(() => import('./checklist/ChecklistPage'));
const ComparePage = lazy(() => import('./compare/ComparePage'));
const ComparePlansPage = lazy(() => import('./compare-plans/ComparePlansPage'));
const CompoundPage = lazy(() => import('./compound/CompoundPage'));
const SevenKnightsCouponPage = lazy(() => import('./coupon/seven-knights/SevenKnightsCouponPage'));
const DividendPage = lazy(() => import('./dividend/DividendPage'));
const FirePage = lazy(() => import('./fire/FirePage'));
const GuidePage = lazy(() => import('./guide/GuidePage'));
const AgeGuidePage = lazy(() => import('./guide/AgeGuidePage'));
const InflationPage = lazy(() => import('./inflation/InflationPage'));
const PensionPage = lazy(() => import('./pension/PensionPage'));
const RetirementGoalPage = lazy(() => import('./retirement-goal/RetirementGoalPage'));
const RetirementPage = lazy(() => import('./retirement/RetirementPage'));
const QuizPage = lazy(() => import('./quiz/QuizPage'));
const ScenarioPage = lazy(() => import('./scenario/ScenarioPage'));
const SeverancePage = lazy(() => import('./severance/SeverancePage'));
const TaxBenefitPage = lazy(() => import('./tax-benefit/TaxBenefitPage'));

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AppErrorBoundary>
        <RouteChangeTracker />
        <Suspense fallback={<div style={{ minHeight: '100vh' }} />}>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/compound" element={<CompoundPage />} />
              <Route path="/dividend" element={<DividendPage />} />
              <Route path="/pension" element={<PensionPage />} />
              <Route path="/retirement" element={<RetirementPage />} />
              <Route path="/retirement/goal" element={<RetirementGoalPage />} />
              <Route path="/tax-benefit" element={<TaxBenefitPage />} />
              <Route path="/inflation" element={<InflationPage />} />
              <Route path="/checklist" element={<ChecklistPage />} />
              <Route path="/guide" element={<GuidePage />} />
              <Route path="/guide/:ageGroup" element={<AgeGuidePage />} />
              <Route path="/severance" element={<SeverancePage />} />
              <Route path="/fire" element={<FirePage />} />
              <Route path="/quiz" element={<QuizPage />} />
              <Route path="/compare-plans" element={<ComparePlansPage />} />
              <Route path="/scenario/:scenarioId" element={<ScenarioPage />} />
              <Route path="/compare/:type" element={<ComparePage />} />
              <Route path="/coupon/seven-knights" element={<SevenKnightsCouponPage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </Suspense>
      </AppErrorBoundary>
    </ThemeProvider>
  );
}

export default App;
